import styles from './Vitalik.module.scss';

function Vitalik() {
  return (
    <div className={styles.container}>
      <div className={styles.oval1} />
      <div className={styles.oval2} />
    </div>
  );
}

export default Vitalik;
